export default __webpack_public_path__ + "static/media/make4.f7d5795c.png";